<div class="maincontentarea" id="maincontentarea">
    <section class="my_account">
    
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h4 class="accmain-head">Favourites
                         <!-- <a  *ngIf="fav_list2.length"class="favourite_edit_link"  (click)="openModal(EditFavourites)"href="javascript:;">Edit</a> -->
                        </h4>
                </div>
            </div>
            <div>
               
            <div class="row h280" >
              <!-- <p>fdsf</p> -->
               
                <div class="col-md-4" *ngFor="let category of all_list" [routerLink]="['/guruji/favourite']"  [queryParams]="{id: category.category_id}" >
                   
                    <a href="javascript:void(0);" class="favourite_guruji" >
                        
                        <span class="guruji_name w100">{{category.category_name}}</span>

                        <i class="fa fa-chevron-right fav_cat_icon"></i>
                    </a>
                </div>
            
                <!-- <div class="col-md-4">
                    <div class="favourite_guruji">
                        <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" />
                        <span class="guruji_name">Sadhguru</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="favourite_guruji">
                        <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" />
                        <span class="guruji_name">Sadhguru</span>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="favourite_guruji">
                        <img src="../../../../assets/img/guruji_img.jpg" alt="" title="" />
                        <span class="guruji_name">Sadhguru</span>
                    </div>
                </div> -->
            </div>
        </div>
          
        </div>
    </section>
</div>